import _ from 'lodash'
import { resetDmakerTemplate } from '@/api/creative/template'
import { Message } from 'element-ui'
import { resetGmakerTemplate } from '@/api/gmaker/template.js'
import { resetGmakerProject } from '@pt/api/gmaker/project.js'
import { resetDmakerCustom } from '@/api/dmaker/custom.js'

function cookApiParams({ id, page, isResetAll, skinId, templateType }) {
  const resetProject = () => {
    return {
      params: {
        id: id,
      },
      request: resetGmakerProject,
    }
  }
  const commonTemplateCustomApiUtils = {
    'common-template-dco': resetProject,
    'common-template-custom': resetProject,
    'common-template-multi-custom': resetProject,
  }

  const resetDmaker = () => {
    return {
      params: {
        id,
      },
      request: resetDmakerCustom,
    }
  }
  const templateCustomApiUtils = {
    dco: resetDmaker,
    custom: resetDmaker,
    'multi-custom': resetDmaker,
  }

  const templateApiUtils = {
    template: () => {
      if (templateType === 'gm') {
        return {
          params: {
            template_id: id,
            all: isResetAll || 2,
          },
          request: resetGmakerTemplate,
        }
      }
      return {
        params: {
          template_id: id,
          all: isResetAll || 2,
        },
        request: resetDmakerTemplate,
      }
    },
    'common-template': () => {
      return {
        params: {
          template_id: id,
          skin_id: skinId,
        },
        request: resetGmakerTemplate,
      }
    },
  }

  const apiUtils = {
    ...templateApiUtils,
    ...templateCustomApiUtils,
    ...commonTemplateCustomApiUtils,
  }

  return apiUtils[page]() || null
}

/**
 * reset template
 * @param all 是否重置所有资源 1 是，2 否
 * @returns {Promise<null|*>}
 */
export default async function ({ commit, dispatch, state }, { isResetAll }) {
  if (state.isReadonly) {
    Message({
      message: 'Read Only',
      type: 'error',
      duration: 5 * 1000,
    })
    return null
  }

  const apiParams = cookApiParams({
    page: state.page,
    id: state.id,
    isResetAll,
    skinId: state.skinId,
    templateType: state.templateType,
  })

  if (!apiParams) {
    throw new Error('Fail to reset template')
  }

  const res = await apiParams.request(apiParams.params)
  if (_.get(res, 'data.code') !== 0) {
    return null
  }
  return res.data
}
